import { Campus } from '@/modules/core/data/types/Campus';
import { ChatbotContext } from '@/modules/core/data/types/ChatbotContext';
import { EducationalProgramStep } from '@/modules/core/data/types/EducationalProgramStep';
import { StudentSolutionsCategory } from '@/modules/core/data/types/StudentSolutionsCategory';
import { ReactSelectRefLabelOption } from '@/modules/core/reactSelect/types/ReactSelect';
import map from 'lodash.map';

/**
 * Converts a list of categories to a React-Select list of options.
 *
 * @param categories
 */
export const convertCategoriesAsSelectOptions = (categories: StudentSolutionsCategory[]): ReactSelectRefLabelOption[] => {
  return map(categories, (category: StudentSolutionsCategory) => {
    return {
      ref: category.ref,
      label: category.label,
    };
  });
};

/**
 * Filters categories based on the selected programs, program steps and campuses, to make sure we don't propose categories that won't have any result.
 *
 * XXX Not implemented, not sure if something should be done here
 *  Another issue is that some customers always have 1 question displayed "Want to add something" to gather end-user feedback, so counting solutions to filter categories that wouldn't display any solution is trickier
 *
 * @param allCategories
 * @param allCampuses
 * @param allEducationalProgramSteps
 * @param chatbotContext
 */
export const filterCategoriesBySelectedCampusesAndProgramSteps = (allCategories: StudentSolutionsCategory[], allCampuses: Campus[], allEducationalProgramSteps: EducationalProgramStep[], chatbotContext: ChatbotContext): StudentSolutionsCategory[] => {
  return allCategories;
};
